"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComputedTypography = exports.createMuiTypographyOptions = exports.variantNameUsedForMuiButton = exports.defaultGetTypographyDesc = exports.chromeFontSizesFactors = void 0;
var id_1 = require("tsafe/id");
var breakpoints_1 = require("./breakpoints");
var objectKeys_1 = require("tsafe/objectKeys");
var ViewPortAdapter_1 = require("powerhooks/ViewPortAdapter");
Object.defineProperty(exports, "chromeFontSizesFactors", { enumerable: true, get: function () { return ViewPortAdapter_1.chromeFontSizesFactors; } });
var defaultGetTypographyDesc = function (_a) {
    var windowInnerWidth = _a.windowInnerWidth, browserFontSizeFactor = _a.browserFontSizeFactor;
    return ({
        "fontFamily": "sans-serif",
        "rootFontSizePx": 16 * browserFontSizeFactor,
        "variants": {
            "display heading": __assign({ "htmlComponent": "h1", "fontWeight": id_1.id("bold") }, (function () {
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.xl) {
                    return {
                        "fontSizeRem": 2.8,
                        "lineHeightRem": 3.25,
                    };
                }
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                    return {
                        "fontSizeRem": 2.25,
                        "lineHeightRem": 2.5,
                    };
                }
                return {
                    "fontSizeRem": 1.75,
                    "lineHeightRem": 2.5,
                };
            })()),
            "page heading": __assign({ "htmlComponent": "h2", "fontWeight": id_1.id("bold") }, (function () {
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.xl) {
                    return {
                        "fontSizeRem": 2.25,
                        "lineHeightRem": 2.5,
                    };
                }
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                    return {
                        "fontSizeRem": 1.75,
                        "lineHeightRem": 2.25,
                    };
                }
                return {
                    "fontSizeRem": 1.125,
                    "lineHeightRem": 1.25,
                };
            })()),
            "subtitle": __assign({ "htmlComponent": "h3", "fontWeight": id_1.id("normal") }, (function () {
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.xl) {
                    return {
                        "fontSizeRem": 1.75,
                        "lineHeightRem": 2.25,
                    };
                }
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                    return {
                        "fontSizeRem": 1.5,
                        "lineHeightRem": 2,
                    };
                }
                return {
                    "fontSizeRem": 1,
                    "lineHeightRem": 1.475,
                };
            })()),
            "section heading": __assign({ "htmlComponent": "h4", "fontWeight": id_1.id("bold") }, (function () {
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.xl) {
                    return {
                        "fontSizeRem": 1.5,
                        "lineHeightRem": 2,
                    };
                }
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                    return {
                        "fontSizeRem": 1.25,
                        "lineHeightRem": 1.7,
                    };
                }
                return {
                    "fontSizeRem": 0.875,
                    "lineHeightRem": 1.28,
                };
            })()),
            "object heading": __assign({ "htmlComponent": "h5", "fontWeight": id_1.id(600) }, (function () {
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.xl) {
                    return {
                        "fontSizeRem": 1.25,
                        "lineHeightRem": 1.7,
                    };
                }
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                    return {
                        "fontSizeRem": 1.125,
                        "lineHeightRem": 1.25,
                    };
                }
                return {
                    "fontSizeRem": 0.875,
                    "lineHeightRem": 1.28,
                };
            })()),
            "navigation label": __assign({ "htmlComponent": "h5", "fontWeight": id_1.id(500) }, (function () {
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.xl) {
                    return {
                        "fontSizeRem": 1.25,
                        "lineHeightRem": 1.7,
                    };
                }
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                    return {
                        "fontSizeRem": 1.125,
                        "lineHeightRem": 1.25,
                    };
                }
                return {
                    "fontSizeRem": 0.875,
                    "lineHeightRem": 1.28,
                };
            })()),
            "label 1": __assign({ "htmlComponent": "h6", "fontWeight": id_1.id(500) }, (function () {
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.xl) {
                    return {
                        "fontSizeRem": 1,
                        "lineHeightRem": 1.475,
                    };
                }
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                    return {
                        "fontSizeRem": 0.875,
                        "lineHeightRem": 1.28,
                    };
                }
                return {
                    "fontSizeRem": 0.75,
                    "lineHeightRem": 1,
                };
            })()),
            "label 2": __assign({ "htmlComponent": "h6", "fontWeight": id_1.id(500) }, (function () {
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.xl) {
                    return {
                        "fontSizeRem": 0.875,
                        "lineHeightRem": 1.28,
                    };
                }
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                    return {
                        "fontSizeRem": 0.75,
                        "lineHeightRem": 1,
                    };
                }
                return {
                    "fontSizeRem": 0.625,
                    "lineHeightRem": 0.69,
                };
            })()),
            "body 1": __assign({ "htmlComponent": "p", "fontWeight": id_1.id("normal") }, (function () {
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.xl) {
                    return {
                        "fontSizeRem": 1,
                        "lineHeightRem": 1.475,
                    };
                }
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                    return {
                        "fontSizeRem": 0.875,
                        "lineHeightRem": 1.28,
                    };
                }
                return {
                    "fontSizeRem": 0.75,
                    "lineHeightRem": 1,
                };
            })()),
            "body 2": __assign({ "htmlComponent": "p", "fontWeight": id_1.id("normal") }, (function () {
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.xl) {
                    return {
                        "fontSizeRem": 0.875,
                        "lineHeightRem": 1.28,
                    };
                }
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                    return {
                        "fontSizeRem": 0.75,
                        "lineHeightRem": 1,
                    };
                }
                return {
                    "fontSizeRem": 0.625,
                    "lineHeightRem": 0.69,
                };
            })()),
            "body 3": __assign({ "htmlComponent": "p", "fontWeight": "normal" }, (function () {
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.xl) {
                    return {
                        "fontSizeRem": 0.875,
                        "lineHeightRem": 1.28,
                    };
                }
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                    return {
                        "fontSizeRem": 0.75,
                        "lineHeightRem": 1,
                    };
                }
                return {
                    "fontSizeRem": 0.625,
                    "lineHeightRem": 0.69,
                };
            })()),
            "caption": __assign({ "htmlComponent": "p", "fontWeight": id_1.id("normal") }, (function () {
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.xl) {
                    return {
                        "fontSizeRem": 0.75,
                        "lineHeightRem": 1,
                    };
                }
                if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                    return {
                        "fontSizeRem": 0.625,
                        "lineHeightRem": 0.69,
                    };
                }
                return {
                    "fontSizeRem": 0.45,
                    "lineHeightRem": 0.75,
                };
            })()),
        },
    });
};
exports.defaultGetTypographyDesc = defaultGetTypographyDesc;
exports.variantNameUsedForMuiButton = "label 1";
exports.createMuiTypographyOptions = (_a = (function () {
    function getTypographyVariantStyleFactory(params) {
        var _a = params.typographyDesc, fontFamily = _a.fontFamily, rootFontSizePx = _a.rootFontSizePx, variants = _a.variants;
        function getTypographyVariantStyle(params) {
            var variantName = params.variantName;
            var _a = variants[variantName], fontSizeRem = _a.fontSizeRem, lineHeightRem = _a.lineHeightRem, fontWeight = _a.fontWeight, variantFontFamily = _a.fontFamily;
            return {
                "fontFamily": variantFontFamily !== null && variantFontFamily !== void 0 ? variantFontFamily : fontFamily,
                fontWeight: fontWeight,
                //NOTE: We put as any because we use TS 4.2.2 for Storybook but with newer version is not necessary.
                "fontSize": fontSizeRem * rootFontSizePx + "px",
                "lineHeight": lineHeightRem * rootFontSizePx + "px",
            };
        }
        return { getTypographyVariantStyle: getTypographyVariantStyle };
    }
    function getComputedTypography(params) {
        var typographyDesc = params.typographyDesc;
        var getTypographyVariantStyle = getTypographyVariantStyleFactory({
            typographyDesc: typographyDesc,
        }).getTypographyVariantStyle;
        var computedTypography = {
            "rootFontSizePx": typographyDesc.rootFontSizePx,
            "fontFamily": typographyDesc.fontFamily,
            "variants": {},
        };
        objectKeys_1.objectKeys(typographyDesc.variants).forEach(function (variantName) {
            return (computedTypography.variants[variantName] = {
                "style": getTypographyVariantStyle({ variantName: variantName }),
                "htmlComponent": typographyDesc.variants[variantName].htmlComponent,
            });
        });
        return computedTypography;
    }
    function createMuiTypographyOptions(params) {
        var typographyDesc = params.typographyDesc;
        var getTypographyVariantStyle = getTypographyVariantStyleFactory({
            typographyDesc: typographyDesc,
        }).getTypographyVariantStyle;
        return {
            "fontFamily": typographyDesc.fontFamily,
            "fontWeightRegular": "normal",
            "fontWeightMedium": 500,
            "h1": getTypographyVariantStyle({
                "variantName": "display heading",
            }),
            "h2": getTypographyVariantStyle({ "variantName": "page heading" }),
            "h3": getTypographyVariantStyle({ "variantName": "subtitle" }),
            "h4": getTypographyVariantStyle({
                "variantName": "section heading",
            }),
            "h5": getTypographyVariantStyle({
                "variantName": "object heading",
            }),
            "h6": getTypographyVariantStyle({
                "variantName": "navigation label",
            }),
            "subtitle1": getTypographyVariantStyle({
                "variantName": "label 1",
            }),
            "subtitle2": getTypographyVariantStyle({ "variantName": "body 2" }),
            "body1": getTypographyVariantStyle({ "variantName": "body 1" }),
            "body2": getTypographyVariantStyle({ "variantName": "body 2" }),
            "caption": getTypographyVariantStyle({ "variantName": "caption" }),
            "button": getTypographyVariantStyle({
                "variantName": exports.variantNameUsedForMuiButton,
            }),
        };
    }
    return { createMuiTypographyOptions: createMuiTypographyOptions, getComputedTypography: getComputedTypography };
})(), _a.createMuiTypographyOptions), exports.getComputedTypography = _a.getComputedTypography;
//# sourceMappingURL=typography.js.map